import { render, staticRenderFns } from "./TiposSituacao.vue?vue&type=template&id=b1fa998e&"
import script from "./TiposSituacao.vue?vue&type=script&lang=js&"
export * from "./TiposSituacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports